'use client';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import gtm from 'eco-design-reliance/gtm';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import { useState } from 'react';
import { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperArrow } from '../../index-swiper-a1/content';
import './index.scss';

export default function Content({ id, data = {}, initIndex = 0 }: ContentServerProps) {
    const { list = [] } = data;
    const prefixCls = 'index-swiper-b1';
    const [curIndex, setCurIndex] = useState(0);

    const handleGtmBtn = (text: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'banner_switch',
            position: `Homepage_Swiper_2_${text}`,
            button_name: text,

            __btn_id1: `tltwlb-swiper-${text}`,
            __btn_id2: `tltwlb-swiper-${text}`,
            __btn_type: 'common',
        });
    };
    return (
        <GloLayout className={`editor-index-swiper-b1`} id={id} data={data}>
            <Swiper
                initialSlide={initIndex}
                pagination={false}
                navigation={{
                    nextEl: '.swiper-buttons .button-next',
                    prevEl: '.swiper-buttons .button-prev',
                }}
                autoplay={
                    list.length > 1
                        ? {
                              delay: 3500, // 轮播间隔时间（毫秒），默认3000
                              disableOnInteraction: false, // 用户操作后是否停止自动轮播，false表示不停止
                          }
                        : undefined
                }
                loop
                speed={2000}
                modules={[Navigation, Autoplay]}
                onTransitionStart={(e: any) => {
                    setCurIndex(e.realIndex);
                }}
                key={`swiper-aaa-${list.length}`}
            >
                {list.map((item: any, index: number) => {
                    const { label, title, desc, theme = 'white' } = item;
                    const itemClasses = classNames({
                        [`${prefixCls}-item`]: true,
                        [`${prefixCls}-item-${index + 1}`]: true,
                        [`${prefixCls}-theme-${theme}`]: theme,
                    });
                    return (
                        <SwiperSlide className={itemClasses} key={index}>
                            <div className={`${prefixCls}-item-img`}>
                                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} h5={item.h5} />
                            </div>
                            <div className={`${prefixCls}-item-msg`}>
                                <div className={`${prefixCls}-item-info`}>
                                    {label && <div className={`${prefixCls}-item-label`}>{label}</div>}
                                    {title && <div className={`${prefixCls}-item-title`}>{title}</div>}
                                    {desc && <div className={`${prefixCls}-item-desc`}>{desc}</div>}
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
                {list.length > 1 && (
                    <div className={`${prefixCls}-control ${prefixCls}-control-${list[curIndex].theme}`}>
                        <div
                            className={`${prefixCls}-line`}
                            style={{
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-expect-error
                                '--line-width': `${(100 / list.length) * (curIndex + 1)}%`,
                            }}
                        ></div>
                        <div className="swiper-buttons">
                            <div
                                className={`button-prev GtmModuleData-btn-common tltwlb-swiper-Left`}
                                data-btn-id="tltwlb-swiper-Left"
                                onClick={() => handleGtmBtn('Left')}
                            >
                                {SwiperArrow}
                            </div>
                            <div
                                className={`button-next GtmModuleData-btn-common tltwlb-swiper-Right`}
                                data-btn-id="tltwlb-swiper-Right"
                                onClick={() => handleGtmBtn('Right')}
                            >
                                {SwiperArrow}
                            </div>
                        </div>
                    </div>
                )}
            </Swiper>
        </GloLayout>
    );
}
